const SupportingUrl = {
    "HelpCenter" : "https://reveal-help.verizonconnect.com/hc/articles/17190169888787",
    "FAQ_ContractsAndCancellation" : "https://reveal-help.verizonconnect.com/hc/en-us/articles/17190169888787-FAQ-Contracts-and-cancellations",
    "LearnMoreRecipientListUrl" :"https://reveal-help.verizonconnect.com/hc/articles/28735449771667"
}

export default SupportingUrl;